import React, { useState } from "react";
import { Box } from "@mui/material";

import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

const TOPBAR_HEIGHT_DESKTOP = 72;
const TOPBAR_HEIGHT_MOBILE = 96;

const DashboardLayout = ({
  children,
  role,
  activePage,
  title = "Tableau de bord",
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleMenuClick = () => {
    setMobileOpen((prev) => !prev);
  };

  const handleDrawerClose = () => {
    setMobileOpen(false);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {/* ✅ TopBar */}
      <TopBar onMenuClick={handleMenuClick} title={title} />

      {/* ✅ Sidebar */}
      <Sidebar
        role={role}
        activePage={activePage}
        mobileOpen={mobileOpen}
        onMobileClose={handleDrawerClose}
      />

      {/* ✅ Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          px: { xs: 2, sm: 3 },
          pb: 3,
          pt: {
            xs: `${TOPBAR_HEIGHT_MOBILE}px`,
            sm: `${TOPBAR_HEIGHT_DESKTOP}px`,
          },
          backgroundColor: "#f5f6f8",
          minHeight: "100vh",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default DashboardLayout;
